import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { DrawerCard, DrawerEmptyState } from '../../DrawerComponents'
import styles from '../CallDrawerModern.module.scss'

export const CallNotesCard = ({ selectedRow }) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)

  const notes = selectedRow?.[14] || selectedRow?.call_notes

  const hasNotes = notes && notes.trim()

  const isLongText = hasNotes && notes.length > 250
  const displayText = !hasNotes ? null : (isExpanded || !isLongText ? notes : notes.substring(0, 250))

  const timestamp = selectedRow?.[0] || selectedRow?.call_date
  const formattedDate = timestamp ? new Date(timestamp).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }) : null

  const renderBadge = () => {
    if (formattedDate) {
      return (
        <Typography className={styles.callNotesDateBadge}>
          {formattedDate}
        </Typography>
      )
    }
    return null
  }

  return (
    <DrawerCard
      title={t('calls.drawer.callNotes')}
      icon="sticky-note"
      badge={renderBadge()}
      collapsible
      defaultExpanded={!!hasNotes}
    >
      <Box className={styles.callNotesBody}>
        {hasNotes ? (
          <>
            <Box className={styles.callNotesTextWrapper}>
              <Typography className={`${styles.callNotesText} ${!isExpanded && isLongText ? styles.callNotesTextFade : ''}`}>
                {displayText}
              </Typography>
            </Box>

            {isLongText && (
              <button
                className={styles.callNotesToggle}
                onClick={() => setIsExpanded(!isExpanded)}
                type="button"
              >
                <FontAwesomeIcon icon={isExpanded ? 'chevron-up' : 'chevron-down'} />
                {isExpanded ? 'Show Less' : 'Show More'}
              </button>
            )}
          </>
        ) : (
          <DrawerEmptyState
            icon="sticky-note"
            text="No notes available"
          />
        )}
      </Box>
    </DrawerCard>
  )
}

CallNotesCard.propTypes = {
  selectedRow: PropTypes.object
}

export default CallNotesCard
